import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showOfflineMessage, setShowOfflineMessage] = useState(false);
  const [reconnecting, setReconnecting] = useState(false);

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      setShowOfflineMessage(false);
      setReconnecting(false);
      
      // Afficher brièvement un message de reconnexion
      const timer = setTimeout(() => {
        // Optionnel: afficher un toast de reconnexion
      }, 100);
      
      return () => clearTimeout(timer);
    };

    const handleOffline = () => {
      setIsOnline(false);
      setShowOfflineMessage(true);
      setReconnecting(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Afficher le message si déjà hors ligne au chargement
    if (!navigator.onLine) {
      setShowOfflineMessage(true);
    }

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleRetry = async () => {
    setReconnecting(true);
    
    try {
      // Tenter une petite requête pour vérifier la connectivité
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      
      await fetch('/manifest.json', { 
        signal: controller.signal,
        cache: 'no-cache'
      });
      
      clearTimeout(timeoutId);
      
      // Si la requête réussit, mettre à jour l'état
      setIsOnline(true);
      setShowOfflineMessage(false);
    } catch (error) {
      // console.log('Toujours hors ligne:', error.name);
    } finally {
      setReconnecting(false);
    }
  };

  // Ne rien afficher si en ligne
  if (isOnline && !showOfflineMessage) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-red-500 text-white px-4 py-2 text-center text-sm font-medium shadow-lg animate-in slide-in-from-top duration-300">
      <div className="flex items-center justify-center space-x-2">
        {reconnecting ? (
          <RefreshCw className="h-4 w-4 animate-spin" />
        ) : (
          <WifiOff className="h-4 w-4" />
        )}
        
        <span>
          {reconnecting 
            ? 'Reconnexion en cours...' 
            : 'Vous êtes hors ligne - Certaines fonctionnalités peuvent ne pas être disponibles'
          }
        </span>
        
        {!reconnecting && (
          <button
            onClick={handleRetry}
            className="ml-2 bg-white/20 hover:bg-white/30 px-2 py-1 rounded text-xs transition-colors"
          >
            Réessayer
          </button>
        )}
      </div>
    </div>
  );
};

export default NetworkStatus;